module.exports = __webpack_public_path__ + "img/home-slide_1.113d83f6.png";